import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutUs from './components/AboutUs';
import TeamSection from './components/TeamSection';
import GallerySection from './components/GallerySection';
import { ContactSection } from './components/ContactSection';
import Footer from './components/Footer';

function Main() {
  return (
    <div className="flex w-full max-w-full flex-col bg-stone-800">
      <Header />

      <HeroSection />

      <div className="flex w-full max-w-full flex-col bg-white">
        <AboutUs />
        <ServicesSection />
        <TeamSection />
        <GallerySection />

        <section id="contactus" className="flex min-h-0 w-full max-w-full flex-col font-medium">
          <ContactSection />
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Main;
